import * as React from 'react';
import { SvcAnalysisSetListTable } from './SvcAnalysisSetListTable';
import DocumentTitle from '../../../misc/components/DocumentTitle';
import { ODataParams, Query } from '../../../Components/Query';
import { useCurrentStudyConfigurationContext } from '../../../Core/CurrentStudyConfigurationContext';
import { useWebPortalApiClient } from '../../../misc/api/WebPortalTokenClient';
import { QueryOfSvcAnalysisSet } from 'webportalclient';
import { OverreadStatusIdEnum } from '../../../misc/api/apiTypes';

export const SvcAnalysisSetListScreen = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams): Promise<QueryOfSvcAnalysisSet> => {
        let filter = params.filter ? `(${params.filter}) and ` : '';

        filter += `session/visit/subject/site/studyId eq ${study.id}`;

        return await client.client.getSvcAnalysisSets('id,sessionId,started,created,type,analystUserName,status', filter, params.orderby, 'session($expand=visit($expand=subject($expand=site($select=number,studyId))))', params.top, params.skip, undefined, true);
    }

    return (
        <DocumentTitle title="SVC Analysis Sets | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh}
                initialFilters={[
                    { field: "status", condition: "eq", values: [OverreadStatusIdEnum.Pending, OverreadStatusIdEnum.NotStarted] },
                ]}
                initialOrdering={[{ field: "created", condition: "asc" }]}
            >
                <SvcAnalysisSetListTable />
            </Query>
        </DocumentTitle>
    );
};
